// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__O44Sx","content":"Projects_content__WUnk1","title":"Projects_title__IH2+s","projectsItems":"Projects_projectsItems__PDrmJ"};